<template>
  <SIDetailPage
    :pr="pr"
    :locale="localeValue"
    :get-image-url="getImageUrl"
    :contact-text="contactText"
  />
</template>

<script>
import { computed, inject } from 'vue';
import usePageResource from '@/composables/usePageResource';
import useRenderData from '@/composables/useRenderData';
import SIDetailPage from '@/components/si/SIDetailPage.vue';

export default {
  name: 'mes-page',
  components: { SIDetailPage },
  setup() {
    const { pr, getImageUrl } = useRenderData('mes');
    const { pr: works } = usePageResource('works');
    const locale = inject('locale');
    const localeValue = computed(() => locale?.value || '');
    const contactText = computed(() => works.value.contact);

    return {
      pr,
      getImageUrl,
      localeValue,
      contactText,
    };
  },
};
</script>
